export const FACILITY_SELECT = '/facility';
export const SEARCH = '/search';
export const SEARCH_HISTORY = `${SEARCH}/history`;
